// extracted by mini-css-extract-plugin
export default {"modal-actions":"Welcome--modal-actions--FU1Uu","modalActions":"Welcome--modal-actions--FU1Uu"};